import { render, staticRenderFns } from "./formPageDesign.vue?vue&type=template&id=3dfe84cc&"
import script from "./formPageDesign.vue?vue&type=script&lang=js&"
export * from "./formPageDesign.vue?vue&type=script&lang=js&"
import style0 from "./formPageDesign.vue?vue&type=style&index=0&id=3dfe84cc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports